import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  phone: '',
  password: '',
  iduser:'',
  type: null, // Or default it to 0 or ''

};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserCredentials: (state, action) => {
      const { phone, password , iduser , type } = action.payload;
      state.phone = phone;
      state.password = password;
      state.iduser = iduser;
      state.type = type;
    },
    clearUserCredentials: (state) => {
      state.phone = '';
      state.password = '';
      state.iduser = '';
      state.type = '';
    },
  },
});

export const { setUserCredentials, clearUserCredentials } = userSlice.actions;

export default userSlice.reducer;
